import axios from 'axios';

export const fetchVisits = () => {
  return (dispatch, getState) => {
    let params = getState().visits.params
    let headers = {"Content-Type": "application/json"};
    let {token} = getState().auth;
    if (token) {
      headers["Authorization"] = `JWT ${token}`;
    }
    let underscoreParams = {}
    underscoreParams['license_plate'] = params.licensePlate
    underscoreParams['start_date'] = params.startDate
    underscoreParams['end_date'] = params.endDate
    underscoreParams['location_id'] = params.locationId
    underscoreParams['bay'] = params.bay

    return axios.get("/api/visits.json", {headers, params: underscoreParams})
      .then(res => {
        return dispatch({type: 'FETCH_VISITS', visits: res.data});
      }).catch(function (error) {
        if(error.response.status === 401 || error.response.status === 403) {
          dispatch({type: "AUTHENTICATION_ERROR", data: error.response.data});
        } else {
          console.log(`${error.response.status} Server Error!`);
        }
      })
  }
}

export const fetchMoreVisits = () => {
  return (dispatch, getState) => {
    let headers = {"Content-Type": "application/json"};
    let {token} = getState().auth;
    let visits = getState().visits.visits;
    let lastVisit = visits[visits.length - 1]
    let params = getState().visits.params
    let underscoreParams = {}
    underscoreParams['license_plate'] = params.licensePlate
    underscoreParams['start_date'] = params.startDate
    underscoreParams['end_date'] = params.endDate
    underscoreParams['location_id'] = params.locationId
    underscoreParams['bay'] = params.bay
    underscoreParams['after'] = lastVisit.triggered_at

    if (token) {
      headers["Authorization"] = `JWT ${token}`;
    }

    return axios.get("/api/visits.json", {headers, params: underscoreParams})
      .then(res => {
        return dispatch({type: 'FETCH_MORE_VISITS', visits: res.data});
      }).catch(function (error) {
        if(error.response.status === 401 || error.response.status === 403) {
          dispatch({type: "AUTHENTICATION_ERROR", data: error.response.data});
        } else {
          console.log(`${error.response.status} Server Error!`);
        }
      })
  }
}

export const fetchSingleVisit = (id) => {
  return (dispatch, getState) => {
    let headers = {"Content-Type": "application/json"};
    let {token} = getState().auth;

    if (token) {
      headers["Authorization"] = `JWT ${token}`;
    }

    return axios.get(`/api/visits/${id}.json`, {headers})
      .then(res => {
        return dispatch({type: 'FETCH_SINGLE_VISIT', visit: res.data});
      }).catch(function (error) {
        if(error.response.status === 401 || error.response.status === 403) {
          dispatch({type: "AUTHENTICATION_ERROR", data: error.response.data});
        } else {
          console.log(`${error.response.status} Server Error!`);
        }
      })
  }
}

export const fetchRecording = (id) => {
  return (dispatch, getState) => {
    let headers = {"Content-Type": "application/json"};
    let {token} = getState().auth;

    if (token) {
      headers["Authorization"] = `JWT ${token}`;
    }
    return axios.get(`/api/recordings/${id}.json`, {headers})
      .then(res => {
        return dispatch({type: 'FETCH_RECORDING', recording: res.data});
      }).catch(function (error) {
        if(error.response.status === 401 || error.response.status === 403) {
          dispatch({type: "AUTHENTICATION_ERROR", data: error.response.data});
        } else {
          console.log(`${error.response.status} Server Error!`);
        }
      })
  }
}

export const updateParams = (params) => {
  return(dispatch, getState) => {
    dispatch({type: 'UPDATE_PARAMS', params: params})
  }
}

export const  passUserDataForDemoAccount = () => {
  return (dispatch, getState) => {
    const { user } = getState().auth;
    dispatch({
      type: 'PASS_USER_DATA_FOR_DEMO_ACCOUNT',
      user: user
    });
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/visits.js